/*
 Use reconfigure to setup the loggers.
 It accepts a config object. The object can have these values:
 extraData - object, contains data to add to every error message
 consoleLog - boolean, if true will log errors to console
 loggleKey - string, for logging errors to loggly
 logglyTags - array, tags used for loggly identification
 */
'use strict';
define('errorHandler',['loggly', 'jquery'], function (_LTracker, $) {
	var callbacks = [errorToConsole],
		extraData = {},
		playerData = {},
		startTime = Date.now(),
		statistics = {
			successfulStreams: 0,
			failedStreams: 0,
			errors: 0,
			uptime: 0
		};

	function setupLoggly(key, tags) {
		_LTracker.push({
			logglyKey: key,
			tag: tags.join(',')
		});
	}

	function errorToConsole(error) {
		// eslint-disable-next-line no-console
		console.error(error);
	}

	function errorToLoggly(error) {
		_LTracker.push(error);
	}

	function errorToScreen(error, time) {
		$('#error').html(error).fadeIn(500);

		setTimeout(function () {
			$('#error').fadeOut(500);
		}, time);
	}

	function logError(reportLevel, reportMessage, response, additionalInfo) {
		var generatedReport = {
			level: reportLevel,
			message: reportMessage,
			appStartTime: new Date(startTime),
			appUpTime: Date.now() - startTime,
			playerData: playerData
		};

		// Info is not error
		if (reportLevel !== 'INFO') {
			statistics.errors++;
		}

		// Add error
		if (response) {
			Object.assign(generatedReport, {
				errorData: {
					responseText: response.responseText,
					status: response.status,
					statusText: response.statusText
				}
			});
		}

		// Add specific report data
		if (additionalInfo) {
			Object.assign(generatedReport, additionalInfo);
		}

		// Add configuration data
		Object.assign(generatedReport, extraData);

		callbacks.forEach(function (cb) {
			cb(generatedReport);
		});
	}

	function reportLatestData() {
		statistics.uptime = Date.now() - startTime;

		logError('INFO', 'hourly statistics report', null, { statistics: statistics });
		setTimeout(reportLatestData, 60 * 60 * 1000); // Report every hour

		statistics.successfulStreams = 0;
		statistics.failedStreams = 0;
		statistics.errors = 0;
	}

	return {
		stat: statistics,
		logError: logError,
		showError: errorToScreen,
		playerData: playerData,
		reconfigure: function (config) {
			var handlers = [];

			if (config.consoleLog) {
				handlers.push(errorToConsole);
			}

			if (config.logglyKey) {
				setupLoggly(config.logglyKey, config.logglyTags);
				handlers.push(errorToLoggly);
			}

			extraData = config.extraData;
			callbacks = handlers;
			setTimeout(reportLatestData, (60 - new Date().getMinutes()) * 60 * 1000);
		}
	};
});

